var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-270 -41) translate(270 41)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.81,
    height: 2.138,
    rx: 1.069
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.81,
    height: 2.138,
    y: 17.107,
    rx: 1.069
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.81,
    height: 2.138,
    y: 8.554,
    rx: 1.069
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.388eb539ff5bbce1fec1d37e0f43589c.svg";
export { ForwardRef as ReactComponent };